import React from 'react'
import { connect } from 'react-redux'
import { getBaseSiteIdFromStudy } from 'utils/misc'
import ClinroIframe from '../components/ClinroIframe'

const mapStateToProps = state => {
  const { user, study } = state
  let userToken = user?.token || user?.access_token
  if (!userToken) {
    try {
      const stored = JSON.parse(localStorage.getItem('user') || '{}')
      userToken = stored.token || stored.access_token
    } catch (e) {
      // ignore
    }
  }
  const studyId = study?.currentStudy?.id
  const siteId = getBaseSiteIdFromStudy(study)

  return {
    userToken,
    studyId,
    siteId,
  }
}

export default connect(mapStateToProps)(ClinroIframe)

